import React from 'react'
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import ExpansionPanelTitleAvatar from "components/ExpansionPanelTitleAvatar";
import Tr from "translations/Translations";
import moment from "libs/moment";
import DateFormats from "constants/DateFormats";
import {getSectionVariant} from "../../../../constants/StageSections";
import {makeStyles} from "@material-ui/styles";

const useStyle = makeStyles(theme => ({
    offerDate: {
        marginLeft: theme.spacing(5),
        fontStyle: "italic"
    }
}))

function AuctionOfferPlacedSectionTitle(
    {
        section
    }) {
    const classes = useStyle();

    return (
        <div>
            <GridBlock alignItems="center">
                <ExpansionPanelTitleAvatar variant={getSectionVariant(section)}/>
                <Typography variant='h6'>
                    {section.name}
                </Typography>
            </GridBlock>
            <GridBlock justify="space-between">
                {!!section.endDate &&
                    <Typography className={classes.offerDate}>
                        {Tr('additional_round_end_date_auction')}: {moment(section.endDate).format(DateFormats.DATETIME_FORMAT)}
                    </Typography>
                }
                {!!section.offerDate &&
                    <Typography className={classes.offerDate}>
                        {Tr('offer_date_additional_auction')}: {moment(section.offerDate).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT)}
                    </Typography>
                }
            </GridBlock>
        </div>
    )

}

AuctionOfferPlacedSectionTitle.propTypes = {
    expanded: PropTypes.bool.isRequired,
    section: PropTypes.shape({
        section: PropTypes.string.isRequired
    }).isRequired
}

export default AuctionOfferPlacedSectionTitle;